import {emotionStyled} from '@packages/utilities/styled';
import {CloseButton} from '../../CloseButton';

import {hoverSelector, zIndex} from '../../../utils';

export const ModalCloseButtonView = emotionStyled(CloseButton)(
  {
    zIndex: zIndex.modalCloseButton,
    '&&&&': {
      borderRadius: '$2',
    },
    [hoverSelector]: {
      background: '$uiBackgroundHover',
    },
  },
  {
    componentName: 'ModalCloseButton',
    variants: {
      shouldUseLegacyPosition: {
        true: {
          position: 'absolute',
          top: '$2',
          right: '$2',
        },
      },
    },
  }
);
